/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Delete_Confirm_DescriptionInputs */

const en_story_bank_delete_confirm_description = /** @type {(inputs: Story_Bank_Delete_Confirm_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This action cannot be undone.`)
};

const de_story_bank_delete_confirm_description = /** @type {(inputs: Story_Bank_Delete_Confirm_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This action cannot be undone.`)
};

const fr_story_bank_delete_confirm_description = /** @type {(inputs: Story_Bank_Delete_Confirm_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This action cannot be undone.`)
};

const es_story_bank_delete_confirm_description = /** @type {(inputs: Story_Bank_Delete_Confirm_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This action cannot be undone.`)
};

const it_story_bank_delete_confirm_description = /** @type {(inputs: Story_Bank_Delete_Confirm_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This action cannot be undone.`)
};

const nl_story_bank_delete_confirm_description = /** @type {(inputs: Story_Bank_Delete_Confirm_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This action cannot be undone.`)
};

const pl_story_bank_delete_confirm_description = /** @type {(inputs: Story_Bank_Delete_Confirm_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This action cannot be undone.`)
};

const fi_story_bank_delete_confirm_description = /** @type {(inputs: Story_Bank_Delete_Confirm_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This action cannot be undone.`)
};

const da_story_bank_delete_confirm_description = /** @type {(inputs: Story_Bank_Delete_Confirm_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This action cannot be undone.`)
};

const sv_story_bank_delete_confirm_description = /** @type {(inputs: Story_Bank_Delete_Confirm_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This action cannot be undone.`)
};

/**
* | output |
* | --- |
* | "This action cannot be undone." |
*
* @param {Story_Bank_Delete_Confirm_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_delete_confirm_description = /** @type {((inputs?: Story_Bank_Delete_Confirm_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Delete_Confirm_DescriptionInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_delete_confirm_description(inputs)
	if (locale === "fr") return fr_story_bank_delete_confirm_description(inputs)
	if (locale === "es") return es_story_bank_delete_confirm_description(inputs)
	if (locale === "it") return it_story_bank_delete_confirm_description(inputs)
	if (locale === "nl") return nl_story_bank_delete_confirm_description(inputs)
	if (locale === "pl") return pl_story_bank_delete_confirm_description(inputs)
	if (locale === "fi") return fi_story_bank_delete_confirm_description(inputs)
	if (locale === "da") return da_story_bank_delete_confirm_description(inputs)
	if (locale === "sv") return sv_story_bank_delete_confirm_description(inputs)
	return en_story_bank_delete_confirm_description(inputs)
});